import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { AuditTrail } from './AuditTrail';
import { useTranslation } from 'react-i18next';
import { ErrorCodes } from 'src/common/responseCodes';

const IGNORED_ERRORS = [ErrorCodes.NotFound];

export const AuditTrailPage = () => {
  const { t } = useTranslation();
  return (
    <TabPanelWithErrorHandling
      name={t('simInventory.details.tabs.auditTrail')}
      ignoreErrorMessages={IGNORED_ERRORS}
    >
      <AuditTrail />
    </TabPanelWithErrorHandling>
  );
};
